import { dehydrate } from "@tanstack/react-query";
import { GetServerSidePropsContext } from "next";
import TrackDetailContainer from "@/components/container/HorseRacing/TrackDetailContainer";
import termsList from "@/constants/hr-terminology.json";
import { Hr_PastTrack } from "@/graphql/gql/graphql";
import { TermsT } from "@/types/horseRacing";
import { getTrackDetails } from "@/utils/api";
import { getRandomLearningTerms } from "@/utils/horseRacing";
import { loadHorseRacesByTrack, loadHeader } from "@/utils/ssr";

interface TrackDetailProps {
  trackCode: string;
  trackDetails: Hr_PastTrack;
  initialTerms: TermsT;
}

const TrackDetailPage = (props: TrackDetailProps) => (
  <TrackDetailContainer {...props} />
);

export async function getServerSideProps({
  params,
}: GetServerSidePropsContext<{ track: string[] }>) {
  if (params?.track) {
    const [trackCode] = params.track;
    const menuClient = await loadHeader();

    const racesClient = await loadHorseRacesByTrack(menuClient, trackCode);
    const initialTerms = getRandomLearningTerms(termsList.terminology, 3);
    const trackDetailsResults = await getTrackDetails({ trackCode });
    const trackDetails = trackDetailsResults.HS_PastTracks?.[0];

    if (!trackDetails) {
      return {
        notFound: true,
      };
    }
    return {
      props: {
        dehydratedState: dehydrate(racesClient),
        sportSlug: "horse-racing",
        trackCode,
        initialTerms,
        trackDetails,
      },
    };
  }
  return {
    notFound: true,
  };
}

export default TrackDetailPage;
